import React from "react";

import ZdrojeTypyGrid from "b2b/components/zdroje-typy-grid/ZdrojeTypyGrid";
import ZdrojeGrid from "b2b/components/zdroje-grid/ZdrojeGrid";
import ProduktyGrid from "b2b/components/produkty-grid/ProduktyGrid";
import DoplnkoveSluzbyGrid from "b2b/components/doplnkove-sluzby-grid/DoplnkoveSluzbyGrid";

export function Zdroje() {
  return (
    <>
      <ZdrojeTypyGrid />
      <ZdrojeGrid />
      <ProduktyGrid />
      <DoplnkoveSluzbyGrid />
    </>
  );
}

Zdroje.propTypes = {};

export default React.memo(Zdroje);
